<template>
    <div class="dia_container dia_conf_edit">
        <div class="cl title">
        </div>
        <div class="edit-content">
            <div class="resource-container">
                <div class="cl title">
                    <div class="l name">资源名称</div>
                    <div class="l conf">配置值</div>
                </div>
                <div class="resource-list-container">
                    <div class="cl" v-for="item in resourceList">
                        <div class="l name">{{item.resourcename}}</div>
                        <div class="l conf"><input type="text" v-model="item.conf" /></div>
                    </div>
                </div>
                <div class="dia_btn_container">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import {errorMessage} from '../../util'
    export default {
        props: ['config', 'curPackage', 'curGroup', 'resourceType'],
        data: function(){
            return {
                resource: {
                    conf: '',
                    resourcegroupid: '',
                    resourceid: '',
                    resourcename: '',
                    servicepackagedetailid: '',
                    servicepackageid: ''
                },
                resourceList: [],
            }
        },
        created: function(){
            this.updateResourceList(this.config)
        },
        methods: {
            cancel(){
                this.$emit('cancel')
            },
            save(){
                this.$http.post('/resourceconfig/servicepackage/updatedetail',{
                    servicepackageid: this.curPackage.servicepackageid,
                    resourcegroupid: this.curGroup.resourcegroupid,
                    resourcetype: this.resourceType == '3' ?  '' : this.resourceType,
                    resources: this.getResources()
                }).then(function(res){
                    this.$message.success('保存成功！')
                    this.cancel()
                    this.$emit('refresh')
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            updateResourceList(data){
                let list = []
                data.forEach(item => {
                    let temp = {}
                    for(let i in item) {
                        temp[i] = item[i] ? item[i] : ''
                    }
                    list.push(temp)
                })
                this.resourceList = list
            },
            getResources(){
                let ret = []
                this.resourceList.forEach(item => {
                    let temp = {
                        resourceid: item.resourceid,
                        conf: item.conf,

                    }
                    ret.push(temp)
                })
                return ret
            }
        }
    }
</script>


// WEBPACK FOOTER //
// configResource.vue?54e32318